import { gql } from '@apollo/client/core'

export const GET_LEADERBOARD_QUERY = gql`
  query getLeaderboard($userId: String) {
    getLeaderboard(userId: $userId) {
      ... on GetLeaderboardOutput {
        leaderboard {
          username
          points
          picture
          rank
        }
      }
      ... on ServerError {
        serverError
      }
    }
  }
`
